import API from "./baseService";

export const fetchFormMetadata = () => API.get("/metadata");
